
function UnitManagerHistory() {
    /// <summary>
    /// This object provides js functions for the Widget.Unit.History.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 13.10.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 13.10.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.bsaid = -1;
    this.bInit = false;
}

UnitManagerHistory.prototype = new vcTemplate();

UnitManagerHistory.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        //init the vcDate
        me.visual.find("#div-date-box").vcDate({
            mode: "Range", align: "center", interval: 1, langID: me.userLangidForCulture, callback: function () {
            if (me.bInit === false) {
                me.reload();
                me.bInit = true;
            }
        } });

        me.visual.find("#entry-list").height(parseInt(me.height - me.visual.find("#div-header").height(), 10));

        //init the keyup event for the filter
        me.filter();
        me.visual.find("#div-filter").vcFilter({ callback: function () {  me.filter(); } });
        //init the commit events for the commit checkboes
        me.initCommit();
        //init the commit all button
        me.visual.find('#btn-commit-all').unbind('click').click(function() { 
           var IDs = new Array();
           me.visual.find('#entry-list.vc-list .vc-list-item.found .chkCommit').not(':checked').each(function () {
             var id = this.id; 
             id = id.replace('chkCommit', '');
             IDs.push(id);
           });
           me.commit(IDs);
         }); 
        //init the reload button
        me.visual.find('#btn-reload').unbind('click').click(function () { me.reload(); });
       // me.reload();
    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}



UnitManagerHistory.prototype.initCommit = function () {
    /// <summary>
    /// This function inits the history commit button.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find('.chkCommit').unbind('click').click(function() { 
         var id = $(this).attr('id');
         id = id.replace('chkCommit', '');
         me.commit([id]);
         });
        return true;
    } catch (ex) { me.writeError('initCommit', ex); return false }

}


UnitManagerHistory.prototype.commit = function (IDs) {
    /// <summary>
    /// This function inits the history commit button.
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({ 'LoggerID': me.blid }),"",1,2 ,JSON.stringify({'IDs':IDs}),
         function (result) {

             if (result == null) { alert(me.resources.err_saveData); return false; }
             for (var i=0;i<IDs.length;i++) {    
              me.visual.find('#spanCommit'+IDs[i]).hide();
             }

        //send a MQ-event for the updating of the history notification in the unit manager
         _VCMQ.produce(me.visual, me.vcgid, 'UNITHISTORY_COMMIT', '');
             return true;
         });
        return true;
    } catch (ex) { me.writeError('commit', ex); return false }

}


UnitManagerHistory.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find("#entry-list.vc-list .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", "#entry-list.vc-list .vc-list-item", "found");

        me.visual.find("#entry-list.vc-list .vc-list-item.found").show();
        me.visual.find("#entry-list.vc-list .vc-list-item").removeClass("alt");
        me.visual.find("#entry-list.vc-list .vc-list-item.found:even").addClass("alt");


        return true;
    } catch (ex) {
        me.writeError('filter', ex);
        return false;
    }

};


UnitManagerHistory.prototype.reload = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        var filtertype = me.visual.find('#ddl-filter-type').val();
        var dates = me.visual.find("#div-date-box").vcDate("getDateRange");
       

        me.visual.find('#entry-list').html(me.vcC.getLoadingIcon());
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({ 'LoggerID': me.blid }), '', 1, 2, JSON.stringify({ 'type': 0, filterAlarmId: me.filterAlarmId,'filtertype':filtertype, 'startdate': dates.from, 'enddate': dates.to, 'ShowAllMyProjects': me.showMyProjects}),
           function (result) {
               if (result == null) { alert(me.resources.err_loadData); return false; }
            me.visual.find('#entry-list').html(result);
            me.initCommit();
               me.filter();
             return true;
           });
         
        return true;
    } catch (ex) { me.writeError('reload', ex); return false }

}
